import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { CHAPTERS, IMAGES } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section
      id="story"
      ref={ref}
      data-testid="story-section"
      className="relative bg-[#1C2541] py-16 md:py-24 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <span className="font-label text-xs text-primary">
                  Our Story
                </span>
              </Reveal>
              <Reveal delay={0.05}>
                <h2 className="mt-4 font-display text-5xl md:text-6xl text-[#F8F5F2] leading-none">
                  A neighborhood built on good times.
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <div className="mt-8 overflow-hidden rounded-md border border-white/10">
                  <motion.img
                    style={{ y }}
                    src={IMAGES.story}
                    alt="Cheers at Alley Pub"
                    className="h-72 w-full object-cover scale-110"
                  />
                </div>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.08}>
                <div className="border-t border-white/10 py-10 first:border-t-0 first:pt-0">
                  <div className="flex items-start gap-6">
                    <span className="font-display text-5xl md:text-6xl text-stroke leading-none">
                      {c.no}
                    </span>
                    <div>
                      <h3 className="font-display text-3xl md:text-4xl text-[#F8F5F2]">
                        {c.title}
                      </h3>
                      <p className="mt-3 max-w-xl text-[#F8F5F2]/75 text-base md:text-lg leading-relaxed">
                        {c.body}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
